import React from "react";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

import dlFooter from "../assect/images/svg/dl_footerlogo.svg"
import dlFFB from "../assect/images/svg/DL_FB.svg"
import dlIG from "../assect/images/svg/DL-Insta.svg"

import { FiShoppingCart, FiDribbble, FiLinkedin, FiFacebook, FiInstagram, FiTwitter, FiMail, FiMapPin, FiPhone } from "../assect/icons/vander"

export default function Footer() {
    return (
        <>

            <footer className="bg-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footer-py-60 footer-border">
                                <div className="row">
                                    <div className="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                                        <ul className="list-unstyled footer-list mt-4">
                                            <li>
                                                <Link to="#" className="logo-footer">
                                                    <img src={dlFooter} width="150" alt="" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <ul className="list-unstyled footer-list mt-sm-4">
                                            <li><Link reloadDocument to={{ pathname: "/PropertyListing", search: "propertyType=F", key: uuidv4() }} className="text-foot"><i className="align-middle me-1"></i> FURNISHED</Link></li>
                                            <li><Link reloadDocument to={{ pathname: "/PropertyListing", search: "propertyType=U", key: uuidv4() }} className="text-foot"><i className="align-middle me-1"></i> UNFURNISHED</Link></li>
                                            <li><Link reloadDocument to={{ pathname: "/PropertyListing", search: "propertyType=SF", key: uuidv4() }} className="text-foot"><i className="align-middle me-1"></i> SEMI-FURNISHED</Link></li>
                                        </ul>
                                    </div>

                                    <div className="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <ul className="list-unstyled footer-list mt-sm-4">
                                            <li><Link to="/AboutUs" className="text-foot"><i className="align-middle me-1"></i> ABOUT</Link></li>
                                            <li><Link to="/contactus" className="text-foot"><i className="align-middle me-1"></i> CONTACT US</Link></li>
                                        </ul>
                                    </div>

                                    <div className="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <ul className="list-unstyled footer-list mt-sm-4">
                                            <li><Link to="/discovertroy" className="text-foot"><i className="align-middle me-1"></i> DISCOVER TROY</Link></li>
                                        </ul>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <ul className="list-unstyled footer-list mt-sm-4">
                                            <li>
                                                {/* <a href="javascript:void(0);" target="_blank">
                                                    <img src={dlFFB} width="40" alt="Facebook" style={{ paddingRight: "5px" }} />
                                                </a> */}
                                                  <a href="https://www.facebook.com/people/Dimora-Living/61572466509114/?sk=about" target="_blank">
                                                    <img src={dlFFB} width="40" alt="Facebook" style={{ paddingRight: "5px"}}/>
                                                </a>
                                                &nbsp;
                                                <a href="https://www.instagram.com/dimora_living/" target="_blank">
                                                    <img src={dlIG} width="40" alt="Instagram" style={{ paddingLeft: "5px" }} />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
        </>
    )
}